import RedCloseIcon from '@/common/assets/icons/redCloseIcon.svg?react';
import { Box, Center } from 'styled-system/jsx';
import Typography from '@/common/components/base/typography/Typography.tsx';
import Button from '@/common/components/base/button/Button.tsx';
import MainModal from '@/common/components/base/modal/Modal.tsx';
import { MainModalProps } from '@/common/components/base/modal/Modal.type.ts';
import { useNavigate } from 'react-router-dom';
import { AUTH_LINKS } from '@/modules/Auth/AUTH_LINKS.ts';

export default ({ open, closeModal }: MainModalProps) => (
  <MainModal closeModal={closeModal} open={open}>
    <NotRegisteredModal />
  </MainModal>
);

const NotRegisteredModal = () => {
  const navigate = useNavigate();
  const onBtnClick = () => {
    navigate(AUTH_LINKS.register);
  };
  return (
    <Box>
      <Center mb="20px">
        <RedCloseIcon />
      </Center>
      <Typography mb="20px">
        کاربر عزیز شماره‌ی شما به عنوان کارشناس ثبت نشده است ؛ در صورت تمایل
        می‌توانید تقاضای همکاری خود به عنوان کارشناس را ثبت نمایید.{' '}
      </Typography>
      <Button mb="20px" onClick={() => onBtnClick()} fullWidth>
        متقاضی همکاری
      </Button>
    </Box>
  );
};
